import ImageFallback    from "../components/imageFallback.js";
import { LogsMapping }  from "../logs/exports.js";
import Store            from "../store.js";

import {
    getDeepObjectValue,
    parseHTMLTags,
    parseVariables
} from "./logParser.js";

function renderTags(log, tags, renderer) {

    function subRenderTags(tags) {
        return tags.flatMap((entry) => {
            if (typeof entry === "string") {
                return parseVariables(entry).flatMap((part) => {
                    if (typeof part === "string") {
                        return part;

                    } else {
                        const value             = getDeepObjectValue(log, part.field);
                        const logMapper         = LogsMapping.get(log.type);
                        const variableRender    = logMapper.variables?.[part.str];

                        if (variableRender)
                            return variableRender(log, renderer);

                        if (part.str[0] === "%") {
                            const index = Number(part.str[1]);

                            if (log.type === "user_update_avatar" || log.type === "member_update_guild_avatar") {
                                const avatarHash = (index === 1)
                                    ? log.extra.oldAvatarHash
                                    : log.extra.newAvatarHash;

                                const alt = (index === 1)
                                    ? "Ancien avatar"
                                    : "Nouveau avatar";

                                const src = (log.type === "user_update_avatar")
                                    ? `https://cdn.discordapp.com/avatars/${log.executor}/${avatarHash}?size=4096`
                                    : `https://cdn.discordapp.com/guilds/${Store.me.guildMember.guildId}/users/${log.executor}/avatars/${avatarHash}?size=4096`;

                                return <ImageFallback class="log-avatar-picture" src={src} default="https://cdn.discordapp.com/embed/avatars/0.png" alt={alt} />;

                            } else if (log.type === "user_update_username") {
                                const username = (index === 1)
                                    ? log.extra.oldUsername
                                    : log.extra.newUsername;

                                return <span class="log-code">{username}</span>;

                            } else if (log.type === "user_update_globalname") {
                                const globalName = (index === 1)
                                    ? log.extra.oldGlobalName
                                    : log.extra.newGlobalName;

                                return <span class="log-code">{globalName}</span>;
                            }
                        }

                        switch (part.str) {
                            case "executor":
                            case "target":
                                return Array.isArray(value)
                                    ? value.map(renderer.renderUser)
                                    : renderer.renderUser(value);

                            case "extra.channel":
                                return renderer.renderChannelDirect(value.id, value);

                            case "channel":
                            case "from":
                            case "to":
                                return renderer.renderChannel(value);

                            case "extra.roles":
                                return renderer.renderRoles(value);
                        }

                        return value || part.default;
                    }
                });

            } else {
                switch (entry[0]) {
                    case "b":
                        return <b>{subRenderTags(entry[1])}</b>;

                    case "i":
                        return <i>{subRenderTags(entry[1])}</i>;

                    default:
                        throw new Error("Invalid HTML tag.");
                }
            }
        });
    }

    return subRenderTags(tags);
}

export function renderLog(log, format, renderer) {
    return renderTags(log, parseHTMLTags(format), renderer);
}
